import React from 'react';
import IconButton from '../icon-button';
import { Popover, PopoverContent, PopoverTrigger } from '../popover';

const InfoWithPopover = ({ iconSize = 'small', title = null, content = null, ...popoverProps }) => (
  <div className="ws-ui-info-with-popover">
    <Popover
      placement="top-left"
      title={title}
      appearance="dark"
      {...popoverProps}
      description={content}
    >
      <PopoverTrigger>
        <div className="ws-ui-info-with-popover__icon">
          <IconButton glyph="info" size={iconSize} transparent />
        </div>
      </PopoverTrigger>
      <PopoverContent />
    </Popover>
  </div>
);

export default InfoWithPopover;
